import {
  getDataByUrl,
  postDataByUrl,
  deleteDataByUrl,
  putDataByUrl
} from 'requests';



export const getToDos = () => getDataByUrl(`/api/todos/`);

export const getToDosBYName = (searchName: any) =>
  getDataByUrl(`/api/todos/?q=${searchName}`);

export const getToDosFiltered = (periodicity: any) =>
  getDataByUrl(`/api/todos/`, periodicity);

export const getToDoById = (id: any) => getDataByUrl(`/api/todos/${id}/`);

export const CreateToDos = (toDoFeld: any) =>
  postDataByUrl(`/api/todos/`, toDoFeld);

export const UpdateToDO = (id: any, toDoFeld: any) =>
  putDataByUrl(`/api/todos/${id}/`, toDoFeld);

export const DeliteToDo = (id: any) => deleteDataByUrl(`/api/todos/${id}/`);

